import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";
import { getApprovalConfig } from "@/requests/certificates/employmentCertificate/views/config/certificateApprovals";
import type { CertificateRequest } from "../user/getCertificateRequests";

export const getAllCertificateRequests = async () => {
    try {
        const databaseId = import.meta.env.VITE_APPWRITE_DATABASE_ID;
        const collectionId = import.meta.env.VITE_CERTIFICATE_REQUESTS_COLLECTION_ID;

        if (!databaseId || !collectionId) {
            throw new Error("Missing environment variables");
        }

        const response = await databases.listDocuments(
            databaseId,
            collectionId,
            [Query.orderDesc('requestDate')]
        );

        // Filtrar: RRHH solo ve certificados donde:
        // 1. Requieren RRHH en la config
        // 2. Si también requieren supervisor, este ya debe haber aprobado
        const filteredRequests = (response.documents as unknown as CertificateRequest[]).filter(request => {
            const config = getApprovalConfig(request.type);
            
            const requiresRrhh = config.requiredApprovals.includes('rrhh');
            const requiresSupervisor = config.requiredApprovals.includes('supervisor');
            
            // Si no requiere RRHH, no mostrar
            if (!requiresRrhh) {
                return false;
            }
            
            // Si requiere supervisor, verificar que ya haya aprobado
            if (requiresSupervisor && request.statusBySupervisor !== 'approved') {
                return false;
            }
            
            // Mostrar el certificado
            return true;
        });

        return {
            success: true,
            data: filteredRequests
        };

    } catch (error) {
        console.error("Error fetching all certificate requests:", error);
        return {
            success: false,
            error: error instanceof Error ? error.message : "Error desconocido",
            data: []
        };
    }
};